export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12022.6d93bf72.jpg";